export type DealClassifierDto = {
	id: string;
	name: string;
	deleted: boolean;
	nbrDocuments: number;
	value: string;
};

export type DealClassifierTableColumns = {
	name: string;
	deleted: boolean;
	nbrDocuments: number;
};

export type CreateClassifierRequestProps = {
	dealId: string;
	name: string;
	classifierParentId?: string;
};

export type UpdateClassifierRequestProps = {
	dealId: string;
	dealClassifierId: string;
	classifierParentId?: string | null;
	name: string;
	archive?: boolean;
};

export type Classifier = {
	dealClassifierId?: string;
	classifierId?: string;
	name: string;
	archive?: boolean;
	classifierParentId?: string | null;
	dealId?: string;
	children?: Classifier[];
};

export enum ClassifierFields {
	name = 'name',
	archive = 'archive',
	classifierParentId = 'classifierParentId',
}

export enum CreateClassifierFields {
	name = ClassifierFields.name,
	classifierParentId = ClassifierFields.classifierParentId,
}

export enum EditClassifierFields {
	name = ClassifierFields.name,
	archive = ClassifierFields.archive,
	classifierParentId = ClassifierFields.classifierParentId,
}
